/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuctionDto } from '../models/auction-dto';
import { AuctionHierarchyDto } from '../models/auction-hierarchy-dto';
import { AuctionOptionDto } from '../models/auction-option-dto';
import { findAuctions } from '../fn/auction/find-auctions';
import { FindAuctions$Params } from '../fn/auction/find-auctions';
import { getArchivedAuctionYears } from '../fn/auction/get-archived-auction-years';
import { GetArchivedAuctionYears$Params } from '../fn/auction/get-archived-auction-years';
import { getAuction } from '../fn/auction/get-auction';
import { GetAuction$Params } from '../fn/auction/get-auction';
import { getAuctionOptions } from '../fn/auction/get-auction-options';
import { GetAuctionOptions$Params } from '../fn/auction/get-auction-options';
import { patchAuction } from '../fn/auction/patch-auction';
import { PatchAuction$Params } from '../fn/auction/patch-auction';

@Injectable({ providedIn: 'root' })
export class GeneratedAuctionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAuctions()` */
  static readonly FindAuctionsPath = '/api/auctions';

  /**
   * Finds auctions by given filters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAuctions()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAuctions$Response(params?: FindAuctions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuctionHierarchyDto>>> {
    return findAuctions(this.http, this.rootUrl, params, context);
  }

  /**
   * Finds auctions by given filters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAuctions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAuctions(params?: FindAuctions$Params, context?: HttpContext): Observable<Array<AuctionHierarchyDto>> {
    return this.findAuctions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AuctionHierarchyDto>>): Array<AuctionHierarchyDto> => r.body)
    );
  }

  /** Path part for operation `getAuction()` */
  static readonly GetAuctionPath = '/api/auctions/{id}';

  /**
   * Gets an auction by its given id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuction()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuction$Response(params: GetAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionHierarchyDto>> {
    return getAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets an auction by its given id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuction(params: GetAuction$Params, context?: HttpContext): Observable<AuctionHierarchyDto> {
    return this.getAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionHierarchyDto>): AuctionHierarchyDto => r.body)
    );
  }

  /** Path part for operation `patchAuction()` */
  static readonly PatchAuctionPath = '/api/auctions/{id}';

  /**
   * Updates bidder-specific auction parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchAuction()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchAuction$Response(params: PatchAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionDto>> {
    return patchAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates bidder-specific auction parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchAuction$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchAuction(params: PatchAuction$Params, context?: HttpContext): Observable<AuctionDto> {
    return this.patchAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionDto>): AuctionDto => r.body)
    );
  }

  /** Path part for operation `getArchivedAuctionYears()` */
  static readonly GetArchivedAuctionYearsPath = '/api/auctions/years/archived';

  /**
   * Gets all years in which archived auctions appear.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getArchivedAuctionYears()` instead.
   *
   * This method doesn't expect any request body.
   */
  getArchivedAuctionYears$Response(params?: GetArchivedAuctionYears$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
    return getArchivedAuctionYears(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all years in which archived auctions appear.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getArchivedAuctionYears$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getArchivedAuctionYears(params?: GetArchivedAuctionYears$Params, context?: HttpContext): Observable<Array<number>> {
    return this.getArchivedAuctionYears$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<number>>): Array<number> => r.body)
    );
  }

  /** Path part for operation `getAuctionOptions()` */
  static readonly GetAuctionOptionsPath = '/api/auctions/options';

  /**
   * Gets all auction selection optios for all available auctions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuctionOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionOptions$Response(params?: GetAuctionOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuctionOptionDto>>> {
    return getAuctionOptions(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all auction selection optios for all available auctions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuctionOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionOptions(params?: GetAuctionOptions$Params, context?: HttpContext): Observable<Array<AuctionOptionDto>> {
    return this.getAuctionOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AuctionOptionDto>>): Array<AuctionOptionDto> => r.body)
    );
  }

}
